// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"dbecbc1a","229":"0c33e614","260":"769194e3","497":"ea267d06","563":"cc7038e9","624":"7360b217","674":"2afce6b5","925":"30a9fed6"}[chunkId] + ".chunk.js";
};